"use strict";

/*
*
*   CLIENT LOGO UPLOADER
*
*/

// Class definition
var KTUploaderLogo = function () {
	// Elements
	var logo;

	var _initForm = function() {
    logo = new KTImageInput('kt_client_logo');
	}

	return {
		// public functions
		init: function() {
			_initForm();
		}
	};
}();

jQuery(document).ready(function() {
  KTUploaderLogo.init();
});
